import moment from "moment"
function formatDate(number) {
    return moment(number).format("DD-MM-YY HH:mm")
}
function formatOnlyDate(number) {
    return moment(number).format("DD-MM-YY")
}

export { formatDate ,formatOnlyDate}